import React from "react";
import AdminWebsiteOverview from "./AdminWebsiteOverview";
import CustomerServiceWebsiteOverview from "./CustomerServiceWebsiteOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import OnlineCardsSalesOverview from "./OnlineCardsSalesOverview";
import CardHolderWebsiteOverview from "./CardHolderWebsiteOverview";
import NativeMobileApplicationOverview from "./NativeMobileApplicationOverview";
import IVRInteractiveVoiceResponseOverview from "./IVRInteractiveVoiceResponseOverview";
import ContactCenterServicesOverview from "./ContactCenterServicesOverview";
import BulkCardOrderingPortalOverview from "./BulkCardOrderingPortalOverview";
import ViewVirtualCardOverview from "./ViewVirtualCardOverciew";
import I2cMobileSDKApplicationOverview from "./I2cMobileSDKApplicationOverview";

const InterfacesAndComponentsOverview = ({ data }) => {
  if (!data) return <DataNotFound />;

  return (
    <React.Fragment>
      <AdminWebsiteOverview data={data} />
      <CustomerServiceWebsiteOverview data={data} />
      <OnlineCardsSalesOverview data={data} />
      <CardHolderWebsiteOverview data={data} />
      <NativeMobileApplicationOverview data={data} />
      <IVRInteractiveVoiceResponseOverview data={data} />
      <ContactCenterServicesOverview data={data} />
      <BulkCardOrderingPortalOverview data={data} />
      <ViewVirtualCardOverview data={data} />
      <I2cMobileSDKApplicationOverview data={data} />
    </React.Fragment>
  );
};

export default InterfacesAndComponentsOverview;
